// extracted by mini-css-extract-plugin
export default {"studentChat":"studentChat_studentChat__-3gBp"};